import React, { useState } from "react";

const ServiceDesktop = () => {
  const [hoveredSegment, setHoveredSegment] = useState<any>(null);

  const total = 356;
  const data = [
    {
      id: "myhealth",
      label: "My health",
      value: 135,
      percentage: ((135 / total) * 100).toFixed(1),
      color: "rgb(147, 197, 253)", // blue-300
      startAngle: 0,
      endAngle: 90,
    },
    {
      id: "labtest",
      label: "Lab Test",
      value: 75,
      percentage: ((75 / total) * 100).toFixed(1),
      color: "rgb(167, 243, 208)", // emerald-200
      startAngle: 90,
      endAngle: 180,
    },
    {
      id: "immunization",
      label: "Immunization",
      value: 86,
      percentage: ((86 / total) * 100).toFixed(1),
      color: "rgb(251, 191, 36)", // amber-400
      startAngle: 180,
      endAngle: 270,
    },
    {
      id: "consultation",
      label: "Consultation",
      value: 60,
      percentage: ((60 / total) * 100).toFixed(1),
      color: "rgb(156, 163, 175)", // gray-400
      startAngle: 270,
      endAngle: 360,
    },
  ];

  const radius = 40;
  const strokeWidth = 12;
  const viewBoxSize = 100;
  const center = viewBoxSize / 2;

  const describeArc = (startAngle: number, endAngle: number) => {
    const start = polarToCartesian(center, center, radius, endAngle);
    const end = polarToCartesian(center, center, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    return [
      "M",
      start.x,
      start.y,
      "A",
      radius,
      radius,
      0,
      largeArcFlag,
      0,
      end.x,
      end.y,
    ].join(" ");
  };

  const polarToCartesian = (
    centerX: number,
    centerY: number,
    radius: number,
    angleInDegrees: number
  ) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians),
    };
  };

  return (
    <div className="w-[380px] h-[290px] flex flex-col bg-gray-500 rounded-xl">
      <div className="h-[40px] flex items-center justify-center mt-4">
        <button className="px-6 h-[30px] rounded-2xl bg-[#2C9BD7] font-medium text-[14px] text-[#FFFFFF]">
          Services booked
        </button>
      </div>

      <div className="flex-1 relative flex flex-col items-center justify-between py-2">
        <div className="relative w-[180px] h-[180px]">
          {hoveredSegment && (
            <div className="absolute -right-32 top-0 bg-gray-900 text-white px-4 py-2 rounded-lg shadow-lg z-10">
              <div className="font-semibold">{hoveredSegment.label}</div>
              <div className="flex justify-between gap-4">
                <span>{hoveredSegment.value}</span>
                <span className="text-emerald-400">
                  {hoveredSegment.percentage}%
                </span>
              </div>
            </div>
          )}

          <svg
            width="180"
            height="180"
            viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
            className="transform -rotate-90"
          >
            {data.map((segment) => (
              <path
                key={segment.id}
                d={describeArc(segment.startAngle, segment.endAngle)}
                fill="none"
                stroke={segment.color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                className="transition-opacity duration-200"
                style={{
                  opacity:
                    hoveredSegment && hoveredSegment.id !== segment.id
                      ? 0.5
                      : 1,
                }}
                onMouseEnter={() => setHoveredSegment(segment)}
                onMouseLeave={() => setHoveredSegment(null)}
              />
            ))}

            <circle
              cx={center}
              cy={center}
              r={radius - strokeWidth}
              fill="white"
              className="shadow-lg"
            />
          </svg>

          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-4xl font-bold text-gray-700">{total}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-2 px-6 pb-4">
          {data.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-2"
              onMouseEnter={() => setHoveredSegment(item)}
              onMouseLeave={() => setHoveredSegment(null)}
            >
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-gray-600 text-sm">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceDesktop;
